import React from 'react';
import { connect } from 'react-redux';
import posed from 'react-pose';
import { sprintf } from 'sprintf';
import { request } from 'utils/request';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import * as Types from 'types';

import { Modal } from 'components/modal';
import { GiftWidget } from 'gift/components/GiftWidget';

import { fetchEditions, showGiftEdition } from 'features/editions/actions';
import { fetchEditionsPlaylist } from 'features/playlists/actions';
import { showErrorModal } from 'features/modals/actions';

import { GiftWidgetSuccess } from './GiftWidgetSuccess';

type StateProps = {
  edition?: Types.Edition;
};

type DispatchProps = {
  showGiftEdition: (editionId?: number) => void;
  fetchEditions: () => void;
  fetchEditionsPlaylist: () => void;
  onError: (errorMessage: string) => void;
};

type Props = StateProps & DispatchProps & RouteComponentProps;

type State = {
  success: boolean;
};

const StateSlider = posed.div({
  default: {
    x: 0,
  },
  success: {
    x: '-100%',
    transition: {
      duration: 400,
      type: 'spring',
    },
  },
});

class GiftEdition extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { success: false };
    this.close = this.close.bind(this);
  }

  giftEditionToUser(userEmail: string, message: string = '') {
    const { edition } = this.props;

    if (!edition) {
      // @TODO
      return;
    }

    request
      .post('/certificate_transfers.json', {
        certificate_transfer: {
          receiver_email: userEmail,
          certificate_id: edition.certificate.id,
          message,
        },
      })
      .then(() => {
        this.setState({ success: true });
      })
      .catch(({ data }) => {
        this.props.onError(
          sprintf('Unable to gift edition due to an error: %s', data && data.error),
        );
      });
  }

  close() {
    this.setState({ success: false });
    this.props.showGiftEdition(undefined);
    const wasEditionGifted = this.state.success;
    if (wasEditionGifted) {
      this.props.history.push(Routes.vault_path());
      this.props.fetchEditions();
      this.props.fetchEditionsPlaylist();
    }
  }

  render() {
    return (
      <Modal
        isOpen={!!this.props.edition}
        onRequestClose={this.close}
        style={{
          maxWidth: 420,
          width: '100%',
          minWidth: 288,
          padding: 0,
        }}
        styleContent={{
          overflow: 'hidden',
        }}
      >
        <StateSlider className='d-flex' pose={this.state.success ? 'success' : 'default'}>
          <div style={{ minWidth: '100%' }}>
            <GiftWidget
              onSubmit={(email, message) => this.giftEditionToUser(email, message)}
              onCancel={this.close}
            />
          </div>
          <div style={{ minWidth: '100%' }}>
            <GiftWidgetSuccess enabled={this.state.success} onDoneClick={this.close} />
          </div>
        </StateSlider>
      </Modal>
    );
  }
}

const mapStateToProps = ({ editions }: Types.RootState) => {
  const edition = editions.giftEditionId && editions.byId[editions.giftEditionId];

  return {
    edition,
  };
};

const mapDispatchToProps = {
  fetchEditions,
  fetchEditionsPlaylist,
  showErrorModal,
  onError: showErrorModal,
  showGiftEdition,
};

export const GiftEditionContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    // @ts-ignore
  )(GiftEdition),
);
